import axios from "axios";
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import Details from "./profile_details.jsx";
import Biography from "./biography.jsx";
import Summary from "./summary.jsx";
import WorkExperience from "../work_experience/work_experience.jsx";
import Skills from "../skills/skills.jsx";
import Achievement from "../achievement/achievement.jsx";
import "../../styles/style.css";
import "../../styles/responsive.css";
import { Spinner } from "reactstrap";
import CryptoJS from 'crypto-js';
import { isExpired } from "react-jwt";
import Header from "../../component/header.jsx";
import { env } from "../../config/env";


export default function CareProProfile() {
    const [carepro, setCarepro] = useState({});
    const [workExperience, setWorkExperience] = useState({});
    const [skills, setSkills] = useState({});
    const [achievements, setAchievements] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [imageUrl, setImageUrl] = useState("");
    const navigate = useNavigate();

    const getDownloadUrl = async (url) => {
        const config = {
            headers: {
              "x-api-key": env.IMAGE_ENDPOINT_KEY,
            }
          }
        const response = await axios.get(`${env.IMAGE_ENDPOINT_URL}/carepro-profile-images?url=${url}`, config);
        if(response.data.success){
            const imageUrl = response.data.downloadUrl;
            setImageUrl(imageUrl);
        }
    }

    const loadCarepro = async (agentId) => {
        try {
            const response = await axios.get(`${env.API_ENDPOINT_URL}/careadmin/carepro-profile?agent_id=${agentId}`);

            if (response.data.success) {
                const token = response.data["details"]["profile_token"];
                const expired = isExpired(token);
                
                if(expired){
                    navigate("/link-expired");
                } else {
                    setIsLoading(false);

                    const carepro = response.data["details"];
                    setCarepro(carepro);
                    if(carepro.image_url_s3){
                        getDownloadUrl(carepro.image_url_s3);
                    }
                    
                    const workExperience = response.data["details"]["work_experience"];
                    setWorkExperience(workExperience);
    
                    const skills = response.data["skills"];
                    setSkills(skills);
    
                    const achievements = response.data["achievements"];
                    setAchievements(achievements);
                }
            } else {
                navigate("/link-expired");
            }


        } catch (error) {
            alert(error);
        }
    }

    const loadData = async(agentId) => {
        await loadCarepro(agentId);
    }

    useEffect(() => {
        const params = (new URL(document.location)).searchParams;
        let agentId = params.get("agentId");
        agentId = agentId.replace(/ /g,"+");
        const decrypted = CryptoJS.AES.decrypt(agentId, "CareConcierge");
        agentId = decrypted.toString(CryptoJS.enc.Utf8);
        loadData(agentId);
    }, []);

    return (
        <>
        {
            isLoading ? 
            <center>
                <Spinner />
            </center>:
             <div className="container">
                <Header />
                <div className="content-container">
                    <Details carepro={ carepro } imageUrl={ imageUrl }/>
                </div>
                
                {
                    carepro.biography == null || carepro.biography == ""?
                    <div></div>:
                    <div className="content-container">
                        <Biography bio={ carepro.biography }/>
                    </div>
                }

                <div className="content-container">
                    <Summary carepro={ carepro } skills={ skills } achievements={achievements}/>
                </div>
                
                {
                    workExperience.length === 0?
                    <div></div>:
                    <div className="content-container">
                        <WorkExperience workExperience={ workExperience }/>
                    </div>
                }

                {
                    skills.length === 0? 
                    <div></div>:
                    <div className="content-container">
                        <Skills skills={ skills }/>
                    </div>
                }
                
                {
                    achievements.length === 0?
                    <div></div> :
                    <div className="content-container">
                        <Achievement achievements={achievements}/>
                    </div>
                }
                
            </div>
        }
        </>
    )
}
